import { Box, Text } from "@chakra-ui/react";

import styled from "@emotion/styled";

export const Cards = styled(Box)`
  transition: 0.5s;
  /* padding: 30px; */
  color: ${(props) => props.theme.colors.primary};
  background-color: ${(props) =>
    props.bg ? props.bg : props.theme.colors.secondary};

  &:hover {
    opacity: 0.95;
  }
`;

export const CardText = styled(Text)`
  font-family: ${(props) =>
    props.fontFamily ? props.fontFamily : props.theme.fonts.secondary};
`;
